import * as Sentry from '@sentry/browser'
import { appContext } from '../../common/src/context'
import { hydrateAgentCalendarWidget } from './agentCalendar/agentCalendar'
import { hydrateTranscriptWidget } from './transcript/transcript'
import { hydrateVirtualTourWidget } from './widgets/VirtualTourWidget'
import { hydrateAddAgentWidget } from './widgets/addAgent'
import { hydrateErrorPageWidget } from './widgets/errorPage'
import { hydrateNpsWidget } from './widgets/nps'

if (appContext().isProduction) {
  Sentry.init({
    dsn: 'https://c20a1c7ba01e4af0a77b468c86d4ccd6@o172207.ingest.sentry.io/5204541',
    release: appContext().commitHash,
    environment: 'production',
  })
}

hydrateNpsWidget()
hydrateAddAgentWidget()
hydrateErrorPageWidget()
hydrateAgentCalendarWidget()
hydrateVirtualTourWidget()
hydrateTranscriptWidget()
